import PropTypes from 'prop-types'
import { useEffect, useMemo, useState } from 'react'
import { FormLabel, Modal } from 'react-bootstrap'
import invoiceApi from 'api/invoiceApi'
import { setAppSpinning } from 'app/appSlice'
import CustomSelect from 'general/components/CustomSelect'
import Option from 'general/components/CustomSelect/CustomOption'
import MenuList from 'general/components/CustomSelect/MenuList'
import ToastHelper from 'general/helpers/ToastHelper'
import { useDispatch } from 'react-redux'
import './style.scss'
import ExcelJs from 'exceljs'
import {
  ALPHABET_CHARACTERS,
  EmployeeStatusResidenceData,
  INVOICE_UPLOAD_DATA_MULTIPLE_TAX_RATE_SAMPLES,
  INVOICE_UPLOAD_DATA_SINGLE_TAX_RATE_SAMPLES,
  INVOICE_UPLOAD_GUIDES,
  INVOICE_UPLOAD_HEADER_COLUMNS,
  TYPE_AD_EXCEL,
  TYPE_INVOICE_EXCEL,
} from 'general/constants/AppConstants'
import { filterColumnsBaseOnInvoiceTemplate } from 'general/helpers/ImportInvoiceHelper'
import { useAppSelector } from 'hooks/useRedux'
import Utils, { convertToOptions, findObjectInArray } from 'general/utils/Utils'
import { truncate } from 'lodash'
import ModalValidateUploadInvoiceExcel from 'general/components/Modal/ModalTableInputFile'
import ModalValidateUploadADExcel from 'general/components/Modal/ModalValidateUploadADExcel'
import { unwrapResult } from '@reduxjs/toolkit'
import { thunkNationlity } from 'features/Nationlity/nationlitySlice'
import { thunkIncomeItem } from 'features/IncomeItem/incomeItemSlice'
import dayjs from 'dayjs'
import { thunkSaveAccountingDocuments } from 'features/AccountingDocument/accountDoucmentsSlice'

ModalUploadExcel.prototype = {
  show: PropTypes.bool,
  setShow: PropTypes.func,
  content: PropTypes.string,
  handleConfirm: PropTypes.func,
}

function ModalUploadExcel(props) {
  const dispatch = useDispatch()

  const { show, setShow } = props

  const [selectedInvoiceTemplate, setSelectedInvoiceTemplate] = useState()
  const [selectedFile, setSelectedFile] = useState()
  const [resultText, setResultText] = useState('')
  const [validateFile, setValidateFile] = useState({ show: false })
  const { formatNumber } = useAppSelector((state) => state?.systemConfig)
  const [listNationality, setListNationality] = useState([])
  const [listIncomeItem, setListIncomeItem] = useState([])

  const handleClose = () => {
    setShow({ show: false })
    setResultText('')
    setSelectedInvoiceTemplate()
    setSelectedFile()
  }

  const handleSelectInvoiceSerial = (invoiceTemplate) => {
    setSelectedInvoiceTemplate(invoiceTemplate)
  }

  const getAllNationality = async () => {
    const data = unwrapResult(await dispatch(thunkNationlity({})))
    setListNationality(
      convertToOptions(data?.data ?? [], 'nationalityId', 'nationalityName'),
    )
  }

  const getAllIncomeItem = async (body) => {
    const data = unwrapResult(await dispatch(thunkIncomeItem(body)))
    setListIncomeItem(convertToOptions(data?.data?.items, 'name', 'name'))
  }

  const handleUploadExcel = async ({ notValidate }) => {
    if (!selectedFile) {
      ToastHelper.showError('Chưa chọn file excel')
      return
    }
    console.log('a')
    if (!notValidate) {
      handleFile(selectedFile)
      return
    } else {
      let params = {
        file: selectedFile,
      }
      dispatch(setAppSpinning(true))
      try {
        let res = await invoiceApi.upload(params)
        dispatch(setAppSpinning(false))
        let { successInvoiceSequences, failedInvoiceSequences } = res
        successInvoiceSequences = successInvoiceSequences.map((item) => ({
          ...item,
          success: 'Y',
        }))
        failedInvoiceSequences = failedInvoiceSequences.map((item) => ({
          ...item,
          success: 'N',
        }))
        let combineResult = successInvoiceSequences
          .concat(failedInvoiceSequences)
          .sort((a, b) => a.invoiceSequence - b.invoiceSequence)
        // .map((item) => {
        //   let { index, ...rest } = item
        //   return rest
        // })
        ToastHelper.showSuccess('Upload excel hóa đơn thành công')
        setResultText(
          combineResult.map((item) => JSON.stringify(item)).join(',<br/>'),
        )
      } catch (e) {
        console.log(e)
        setResultText('')
        dispatch(setAppSpinning(false))
      } finally {
        if (typeof props?.refetchListInvoice == 'function') {
          props.refetchListInvoice()
        }
      }
    }
  }

  const columnNumberToName = (num) => {
    let name = ''
    while (num > 0) {
      let rem = (num - 1) % 26
      name = String.fromCharCode(65 + rem) + name
      num = Math.floor((num - 1) / 26)
    }
    return name
  }

  const getCellValue = (cell) => {
    if (!cell) return null

    const v = cell.value
    if (!v) return null

    if (v.formula) return v.result
    if (v.text) return v.text
    return v
  }

  const getCellByColumnName = (row, columnIndex, formatNumber, type) => {
    try {
      if (type == 'number') {
        let result
        const cell = row.getCell(columnIndex)
        switch (cell.type) {
          case ExcelJs.ValueType.Formula:
            let value = cell.value.result ?? null
            if (formatNumber == null) {
              if (typeof value === 'number') {
                result = value
              } else {
                result = Number(
                  value
                    ?.toString()
                    ?.trim()
                    ?.replaceAll('.', '')
                    ?.replace(',', '.'),
                )
              }
            } else {
              if (typeof value === 'number') {
                result = Utils.roundNumber(Number(value), formatNumber)
              } else {
                result = Utils.roundNumber(
                  Number(
                    value
                      ?.toString()
                      ?.trim()
                      ?.replaceAll('.', '')
                      ?.replace(',', '.'),
                  ),
                  formatNumber,
                )
              }
            }
            if (Number.isNaN(result)) {
              result = 0
            }
            return result
          default:
            if (formatNumber == null) {
              if (typeof row.getCell(columnIndex).value === 'number') {
                result = row.getCell(columnIndex)
              } else {
                result = Number(
                  getCellValue(row.getCell(columnIndex))
                    ?.toString()
                    ?.trim()
                    .replaceAll('.', '')
                    ?.replace(',', '.'),
                )
              }
            } else {
              if (typeof row.getCell(columnIndex).value === 'number') {
                result = Utils.roundNumber(
                  Number(getCellValue(row.getCell(columnIndex))),
                  formatNumber,
                )
              } else {
                result = Utils.roundNumber(
                  Number(
                    getCellValue(row.getCell(columnIndex))
                      ?.toString()
                      ?.trim()
                      .replaceAll('.', '')
                      ?.replace(',', '.'),
                  ),
                  formatNumber,
                )
              }
            }
            if (Number.isNaN(result)) {
              result = 0
            }
            return result
        }
      } else {
        return getCellValue(row.getCell(columnIndex))
      }
    } catch (error) {
      console.error(error)
      null
    }
  }

  const handleFile = async (file) => {
    const buffer = await file.arrayBuffer()

    const workbook = new ExcelJs.Workbook()
    await workbook.xlsx.load(buffer)

    const dataSheet = TYPE_AD_EXCEL
    // 3️⃣ Validate data
    const dataValidate = {}
    let sttInvoiceNear
    let currencyInvoiceNear
    setShow(false)
    setValidateFile({ show: true })
    for (let index = 0; index < dataSheet.length; index++) {
      const arrayDataValidate = []
      let DATA_SHEET = dataSheet[index]
      const sheet = workbook.getWorksheet(DATA_SHEET?.label)
      if (!sheet) {
        dataValidate[DATA_SHEET?.value] = arrayDataValidate
      } else {
        // 1️⃣ Header ở dòng 12
        const HEADER_ROW = 1
        const DATA_START_ROW = 2

        const headerRow = sheet.getRow(HEADER_ROW)

        // 👉 headerMap: { headerName: columnIndex }
        const headerMap = {}

        headerRow.eachCell((cell, colNumber) => {
          const headerName = cell.value?.toString().trim().toLowerCase()
          if (!headerName) return
          headerMap[headerName] = colNumber
        })

        console.log('HEADER MAP:', headerMap)

        for (let i = DATA_START_ROW; i <= sheet.rowCount; i++) {
          const row = sheet.getRow(i)
          let taxpayersName = getCellByColumnName(
            row,
            headerMap['họ và tên'],
            null,
            'string',
          )
          let employeeTaxCode = getCellByColumnName(
            row,
            headerMap['mã số thuế'],
            null,
            'string',
          )

          let nameEmployeeNationality = getCellByColumnName(
            row,
            headerMap['quốc tịch'],
            null,
            'string',
          )

          let employeeNationality = findObjectInArray(
            listNationality,
            'label',
            nameEmployeeNationality?.trim(),
          )?.value

          let nameEmployeeStatusResidence = getCellByColumnName(
            row,
            headerMap['cá nhân cư trú/cá nhân không cư trú'],
            null,
            'string',
          )

          let employeeStatusResidence = findObjectInArray(
            EmployeeStatusResidenceData,
            'label',
            nameEmployeeStatusResidence?.trim(),
          )?.value

          let employeeAddress = getCellByColumnName(
            row,
            headerMap['địa chỉ'],
            null,
            'string',
          )

          let employeePhone = getCellByColumnName(
            row,
            headerMap['điện thoại liên hệ'],
            null,
            'string',
          )

          let employeeIdentification = getCellByColumnName(
            row,
            headerMap[
              'số định danh cá nhân, giấy tờ tùy thân hoặc số hộ chiếu'
            ],
            null,
            'string',
          )

          let nameIncome = getCellByColumnName(
            row,
            headerMap['khoản thu nhập'],
            null,
            'string',
          )

          let income = findObjectInArray(
            listIncomeItem,
            'label',
            nameIncome?.trim(),
          )?.value

          const insurance = getCellByColumnName(
            row,
            headerMap['khoản đóng bảo hiểm bắt buộc'],
            0,
            'number',
          )?.toString()

          const benevolenceDonations = getCellByColumnName(
            row,
            headerMap['khoản từ thiện, nhân đạo, khuyến học'],
            0,
            'number',
          )

          let nameIncomeDate = getCellByColumnName(
            row,
            headerMap['thời điểm trả thu nhập'],
            null,
            'string',
          )

          let incomeDate = convertMonthRange(nameIncomeDate)

          const totalTaxableIncome = getCellByColumnName(
            row,
            headerMap['tổng thu nhập chịu thuế phải khấu trừ'],
            0,
            'number',
          )?.toString()

          const totalTaxIncome = getCellByColumnName(
            row,
            headerMap['tổng thu nhập tính thuế'],
            0,
            'number',
          )?.toString()

          const totalDeductedTax = getCellByColumnName(
            row,
            headerMap['số thuế thu nhập cá nhân đã khấu trừ'],
            0,
            'number',
          )?.toString()

          let note = getCellByColumnName(
            row,
            headerMap['ghi chú'],
            null,
            'string',
          )

          arrayDataValidate.push({
            rowExcel: i,
            taxpayersName,
            employeeTaxCode,
            employeeNationality,
            employeeStatusResidence,
            employeeAddress,
            employeePhone,
            employeeIdentification,
            income,
            insurance,
            benevolenceDonations,
            incomeDate,
            totalTaxableIncome,
            totalTaxIncome,
            totalDeductedTax,
            note,
          })
          dataValidate[DATA_SHEET?.value] = arrayDataValidate
          console.log(arrayDataValidate)
        }
        setValidateFile({ show: true, data: dataValidate })
      }
      console.log('VALIDATE RESULT:', dataValidate)
    }
  }

  const downloadFile = (url, filename) => {
    const a = document.createElement('a')
    a.href = url
    a.download = filename || ''
    document.body.appendChild(a)
    a.click()
    document.body.removeChild(a)
  }

  const convertMonthRange = (value) => {
    try {
      if (!value) return null

      const [fromStr, toStr] = value.split('-')

      const start = dayjs(fromStr.trim(), 'MM/YYYY').startOf('month')
      const end = dayjs(toStr.trim(), 'MM/YYYY').endOf('month')

      return [start, end] // ⚠ return dayjs object
    } catch (error) {
      return null
    }
  }

  const handleDownloadSampleExcel = async () => {
    downloadFile(
      `${process.env.REACT_APP_BASE_URL.includes('localhost') ? 'https://v2.vietinvoice.vn' : process.env.REACT_APP_BASE_URL}/resources/Mẫu chứng từ.xlsx`,
      `CT/${String(new Date().getFullYear()).slice(-2)}E.xlsx`,
    )
  }

  const submit = async (values) => {
    try {
      setValidateFile({ ...validateFile, show: false })
      if (!values) return null
      const result = unwrapResult(
        await dispatch(thunkSaveAccountingDocuments(values)),
      )
      if (result?.message == 'success') {
        ToastHelper.showSuccess('Cập nhật dữ liệu thành công')
        handleClose()
        props?.refetchListInvoice()
      } else {
        ToastHelper.showError('Cập nhật dữ liệu thất bại')
      }
      console.log('result', result)
    } catch (error) {
      ToastHelper.showError('Cập nhật dữ liệu thất bại')
    }
  }

  useEffect(() => {
    getAllNationality()
    getAllIncomeItem()
  }, [])

  return (
    <>
      <Modal
        show={show}
        onHide={handleClose}
        centered
        className="ModalUploadInvoiceExcel"
        backdrop="static"
      >
        <Modal.Header closeButton>
          <Modal.Title>
            <span>Upload excel chứng từ</span>
          </Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <div /* className="create-invoice-right-col" */>
            <div className="d-flex flex-row align-items-center w-100 mb-5">
              <FormLabel style={{ flexBasis: '80px' }} className="mb-1">
                Chọn file:
              </FormLabel>

              <div className="d-flex flex-fill align-items-center gap-2">
                {/* input file ẩn */}
                <input
                  id="real-file-input"
                  type="file"
                  className="d-none"
                  accept=".xlsx"
                  onChange={(e) => setSelectedFile(e.target.files?.[0] || null)}
                />

                {/* input giả */}
                <input
                  type="text"
                  className="form-control file-input-disabled"
                  readOnly
                  placeholder="Vui lòng chọn file"
                  value={selectedFile?.name || ''}
                  onClick={() =>
                    document.getElementById('real-file-input').click()
                  }
                  disabled
                />

                {/* nút Browse */}
                <button
                  type="button"
                  className="btn btn-outline-secondary"
                  onClick={() =>
                    document.getElementById('real-file-input').click()
                  }
                  style={{ width: 120 }}
                >
                  Chọn file
                </button>
              </div>
            </div>

            {resultText && <UploadInvoiceNotifi text={resultText} />}
          </div>
        </Modal.Body>

        <Modal.Footer>
          <div className="">
            <button
              className="btn btn-outline-warning mr-4"
              onClick={handleDownloadSampleExcel}
            >
              Tải file excel mẫu
            </button>

            <button
              className="btn btn-success px-8 mr-4"
              onClick={() => {
                handleUploadExcel({
                  notValidate: false,
                })
              }}
              disabled={!selectedFile}
            >
              Tải lên
            </button>

            <button
              className="btn btn-outline-secondary px-8"
              onClick={handleClose}
            >
              Đóng
            </button>
          </div>
        </Modal.Footer>
      </Modal>
      <ModalValidateUploadADExcel
        validateFileData={validateFile.data}
        show={validateFile?.show}
        onHide={() => {
          setValidateFile({ ...validateFile, show: false })
          setShow(true)
          props?.setShow('true')
        }}
        submit={submit}
        datas={validateFile?.data?.[TYPE_AD_EXCEL?.[0].value]}
        listNationality={listNationality}
        setListNationality={setListNationality}
        listIncomeItem={listIncomeItem}
        setListIncomeItem={setListIncomeItem}
      />
    </>
  )
}

function UploadInvoiceNotifi({ text }) {
  return (
    <div className="uin-container mt-5">
      <div className="uin-wrapper d-flex flex-row align-items-center">
        <i
          className="fa-sharp fa-2x fa-light fa-circle-info mr-2"
          style={{ color: '#044868' }}
        ></i>

        <span
          className="uin-text"
          dangerouslySetInnerHTML={{ __html: text }}
        ></span>
      </div>
    </div>
  )
}

export default ModalUploadExcel
